import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { getPatient, updatePatient } from "../../services/GameService";
import "./PatientDetail.css";

// Drill-in view for a single patient: edit profile, plus entry points to
// game configuration (#36) and statistics (#32).
const PatientDetail = () => {
  const { id } = useParams();
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    notes: "",
  });
  const [saved, setSaved] = useState(false);
  const [saveError, setSaveError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const p = await getPatient(id);
      setPatient(p);
      setForm({
        first_name: p.first_name || "",
        last_name: p.last_name || "",
        email: p.email || "",
        notes: p.notes || "",
      });
    } catch (e) {
      setError("Could not load patient.");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSave = async (e) => {
    e.preventDefault();
    setSaveError("");
    setSaved(false);
    try {
      const updated = await updatePatient(id, form);
      setPatient(updated);
      setSaved(true);
    } catch (err) {
      setSaveError("Could not save changes.");
    }
  };

  if (loading) {
    return (
      <div className="patient-detail">
        <p>Loading…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="patient-detail">
        <p className="pd-error">{error}</p>
        <Link to="/admin/patients" className="pd-back">
          ← Back to patients
        </Link>
      </div>
    );
  }

  return (
    <div className="patient-detail">
      <Link to="/admin/patients" className="pd-back">
        ← Back to patients
      </Link>
      <h1>{patient.username}</h1>
      <form className="pd-form" onSubmit={handleSave}>
        <label className="pd-field">
          <span>First name</span>
          <input
            name="first_name"
            value={form.first_name}
            onChange={handleChange}
          />
        </label>
        <label className="pd-field">
          <span>Last name</span>
          <input
            name="last_name"
            value={form.last_name}
            onChange={handleChange}
          />
        </label>
        <label className="pd-field">
          <span>Email</span>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
          />
        </label>
        <label className="pd-field pd-field-wide">
          <span>Notes</span>
          <textarea name="notes" value={form.notes} onChange={handleChange} />
        </label>
        {saveError && (
          <p className="pd-error" role="alert">
            {saveError}
          </p>
        )}
        {saved && (
          <p className="pd-saved" role="status">
            Saved.
          </p>
        )}
        <button type="submit" className="pd-btn pd-btn-primary">
          Save changes
        </button>
      </form>

      <nav className="pd-links" aria-label="Patient sections">
        <Link to={`/admin/patients/${id}/settings`} className="pd-card">
          Configure games
        </Link>
        <Link to={`/admin/patients/${id}/stats`} className="pd-card">
          View statistics
        </Link>
      </nav>
    </div>
  );
};

export default PatientDetail;
